import { em } from 'polished';

export default {
  root: {
    width: em(25),
    height: em(20),
  },
};
